import './Surveys.css';

// Static values copied verbatim from the inspection HTML's <div class="meta">.
// Manually maintained — small enough that automating the count from POLLS
// isn't worth the indirection (and the HTML wording is editorial).

const ITEMS: { label: string; value: string }[] = [
  { label: 'Polls in scope', value: '18 surveys + 1 anchor' },
  { label: 'Pollsters', value: '3 firms' },
  { label: 'Date range', value: 'Sep 2024 → May 2026' },
  { label: 'Total respondents', value: '~14,600' },
];

export default function SummaryStrip() {
  return (
    <div className="summary-strip">
      <div className="summary-strip__grid">
        {ITEMS.map((item) => (
          <div key={item.label} className="summary-strip__item">
            <strong className="summary-strip__label">{item.label}</strong>
            {item.value}
          </div>
        ))}
      </div>
    </div>
  );
}
